import { render, staticRenderFns } from "./tejiafugou.vue?vue&type=template&id=0115d04c&scoped=true&"
import script from "./tejiafugou.vue?vue&type=script&lang=js&"
export * from "./tejiafugou.vue?vue&type=script&lang=js&"
import style0 from "./tejiafugou.vue?vue&type=style&index=0&id=0115d04c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0115d04c",
  null
  
)

export default component.exports